import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const delAxiosMsg = async (channel, id) => {
  try {
    const { accessToken } = store.state.app.user
    const headers = {
      Authorization: `Bearer ${accessToken}`
    }
    const { data } = await axios.delete(`${API_URL.MESSAGES}/${channel}/${id}`, { headers })
    return data
  } catch (e) {
    console.log(e.response.data)

    return {}
  }
}
